import { Spin } from "antd"

const Spinner = () => {
    return (
        <div className='w-full text-center h-full flex items-center justify-center'>
            <Spin size="small"/>
        </div>
    )
}

export default Spinner